// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

// Pages
import HomePage from './Home';
import PrivacyPolicy from './Components/Home/footerlist/privacy_policy';
import PtxinfoPage from './Components/Home/PtxinfoPage';
import Trailer from './Components/Home/pt/Ptxtrailer';
import Termsofservice from './Components/Home/footerlist/terms_of_service';
import Accessibility from './Components/Home/footerlist/accessibility';
import Mobileprofile from './Components/Home/User/mobileprofile';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<Termsofservice />} />
      <Route path="/accessibility" element={<Accessibility />} />
      <Route path="/ptxinfo" element={<PtxinfoPage />} />
      <Route path="/trailer" element={<Trailer />} />
      <Route path="/remove-home-mobile-profile" element={<Mobileprofile />} />

      {/* Catch-all: Redirect unknown paths to Home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
